import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    width: '100vw',
  },
  card: {
    width: '320px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    padding: '30px',
    margin: 'auto',
  },
  title: {
    textAlign: 'center',
    fontSize: '26px',
    fontWeight: 600,
    marginBottom: '16px',
  },
  error: {
    backgroundColor: '#fff0f0',
    color: '#e74c3c',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '15px',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    alignItems: 'center',
  },
  fieldContainer: {
    width: '300px',
  },
  fullInput: {
    width: '270px',
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '15px',
    transition: 'border-color 0.3s',
  },
  button: {
    width: '300px',
    padding: '11px',
    backgroundColor: '#8e7a55',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '15px',
    fontWeight: 500,
    cursor: 'pointer',
    marginTop: '10px',
  },
};

export default function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // 從 location.state 中取得 username 與 token
  const { username, token } = location.state || {};

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  // 檢查是否有必要的驗證資料
  if (!username || !token) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={styles.title}>
            {t('resetPassword.invalidTitle', '非法進入')}
          </h2>
          <div style={styles.error}>
            {t('resetPassword.invalidMessage', '請先完成驗證碼步驟。')}
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (password !== confirmPassword) {
      setMessage(t('resetPassword.mismatch', '兩次輸入的密碼不一致'));
      return;
    }

    try {
      // 呼叫重設密碼 API，並在 header 中附上 token
      const res = await axios.post(
        '/api/reset-password',
        { username, newPassword: password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(
        res.data.message ||
          t('resetPassword.success', '密碼重設成功，請回登入頁')
      );
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setMessage(
        err.response?.data?.message || t('resetPassword.error', '重設失敗')
      );
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{t('resetPassword.title', '重設密碼')}</h2>
        {message && <div style={styles.error}>{message}</div>}
        <form style={styles.form} onSubmit={handleSubmit}>
          <div style={styles.fieldContainer}>
            <input
              style={styles.fullInput}
              type="password"
              placeholder={t(
                'resetPassword.newPasswordPlaceholder',
                '請輸入新密碼'
              )}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div style={styles.fieldContainer}>
            <input
              style={styles.fullInput}
              type="password"
              placeholder={t(
                'resetPassword.confirmPasswordPlaceholder',
                '請再次輸入新密碼'
              )}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <button style={styles.button} type="submit">
            {t('resetPassword.submitButton', '確認重設')}
          </button>
        </form>
      </div>
    </div>
  );
}
